import { render } from "./DisconnectPopup.vue?vue&type=template&id=55d64100&scoped=true"
import script from "./DisconnectPopup.vue?vue&type=script&lang=js"
export * from "./DisconnectPopup.vue?vue&type=script&lang=js"

import "./DisconnectPopup.vue?vue&type=style&index=0&id=55d64100&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d64100"]])

export default __exports__